import React from 'react';

const TextArea = ({
  placeholder = '',
  value = '',
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  label = '',
  error = '',
  disabled = false,
  required = false,
  className = '',
  rows = 3,
  resize = 'vertical',
  ...props
}) => {
  const baseClasses =
    'box-border block w-full rounded-md border border-border bg-surface px-3 py-2 text-xs leading-snug text-ink shadow-none placeholder:text-ink-tertiary focus:border-ink focus:outline-none focus:ring-1 focus:ring-ink transition-colors duration-150';

  const variantClasses = {
    default: 'bg-surface',
    error: 'border-red-300 focus:ring-red-500 focus:border-red-500',
  };

  const resizeClasses = {
    none: 'resize-none',
    vertical: 'resize-y',
    horizontal: 'resize-x',
    both: 'resize',
  };

  const textAreaClasses = `
    ${baseClasses}
    ${variantClasses[error ? 'error' : 'default']}
    ${resizeClasses[resize]}
    ${disabled ? 'bg-surface-muted cursor-not-allowed opacity-60' : ''}
    ${className}
  `.trim();

  return (
    <div className="w-full">
      {label && (
        <label className="mb-1.5 block text-xs font-medium text-ink sm:mb-2 sm:text-sm">
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      <textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        required={required}
        rows={rows}
        className={textAreaClasses}
        {...props}
      />

      {error && <p className="mt-1 text-xs text-red-600 sm:text-sm">{error}</p>}
    </div>
  );
};

export default TextArea;
